<template>

    <div class="grid-container">
        <div>
            <button class="btn btn-primary" :disabled="loading" @click="$emit('get-queue')">
                <i class="fa fa-refresh"></i> {{resource('Button_Refresh')}}
            </button>
        </div>
        <div>
            <b>{{resource('AnalysisSelection_Index_TotalTime_Label')}}</b> {{totalTimeString}}<br />
            <b>{{resource('AnalysisSelection_Index_SelectedTime_Label')}}</b> {{selectedTimeString}}
        </div>
        <div class="grid-item-bottom-right">
            <button class="btn btn-danger" :disabled="loading || selectedTime === 0" @click="clearQueue()">
                <i class="fas fa-trash-alt"></i> {{resource('AnalysisSelection_Index_Button_ClearQueue_DisplayName')}}
            </button>
        </div>
        <div class="grid-item-bottom-right">
            <button class="btn btn-success" :disabled="loading || selectedTime === 0" @click="startAnalysis()">
                <i class="fas fa-play"></i> {{resource('AnalysisSelection_Index_Button_StartAnalysis_DisplayName')}}
            </button>
        </div> 
    </div>
</template>

<script>

//Mixins
import resourceMixin from '../../../../../Core/Util/Mixins/resources';

//Util
import {promptWithIconV2 as prompt}  from '../../../../../Core/Util/prompt';
import growler from '../../../../../Core/Util/growler';
import {sprintf} from 'sprintf-js';

import { secondsToLongTimeString } from '../Util/calls';

export default {
    name: 'analysis-queue-buttons',
    mixins: [resourceMixin],
    methods: {
        clearQueue() {
            const vm = this;

            prompt(
                vm.resource('AnalysisSelection_Index_ClearQueue_Prompt_Title'), 
                sprintf(
                    vm.resource('AnalysisSelection_Index_ClearQueue_Prompt_Body'), 
                    vm.selectedTimeString
                ), 
                'fas fa-exclamation-triangle text-warning'
            ).then(
                () => {
                    vm.$emit('clear-queue');
                }
            );
        },
        startAnalysis() {
            const vm = this;

            prompt(
                vm.resource('AnalysisSelection_Index_StartAnalysis_Prompt_Title'), 
                sprintf(
                    vm.resource('AnalysisSelection_Index_StartAnalysis_Prompt_Body'), 
                    vm.selectedTimeString
                ), 
                'fas fa-exclamation-triangle text-warning'
            ).then(
                () => {
                    vm.$emit('start-analysis');
                },
                () => { /* Do nothing */ }
            );
        }
    },
    computed: {
        totalTimeString() {
            return secondsToLongTimeString(this.totalTime);
        },
        selectedTimeString() {
            return secondsToLongTimeString(this.selectedTime);
        }
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        totalTime: {
            type: Number,
            required: true
        },
        selectedTime: {
            type: Number,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src="../Style/analysis-selection.scss">

</style>